import { Text, View } from 'react-native'
import { DENSE_TABLE_MAX_FONT_SCALE } from '../leagueDetail.constants'
import type { LeagueStandingsTableStyles } from './LeagueStandingsTable.styles'

interface FormHeaderProps {
  styles: LeagueStandingsTableStyles
}

export function FormHeader({ styles }: FormHeaderProps) {
  return (
    <View style={styles.headerRow}>
      <View style={styles.headerRowPadStart} />
      <View style={styles.headerCellRank}>
        <Text style={styles.headerStatLabel}>#</Text>
      </View>
      <View style={styles.headerCellTeamForm}>
        <View style={styles.headerTeamKitSpacer} />
        <Text style={styles.headerTextTeam} numberOfLines={1} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
          Team
        </Text>
      </View>
      <View style={styles.headerCellFormFixed}>
        <Text style={styles.headerText} numberOfLines={1} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
          Last 5
        </Text>
      </View>
      <View style={styles.headerCellPtsForm}>
        <Text style={styles.headerStatLabelEnd} numberOfLines={1} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
          Pts
        </Text>
      </View>
    </View>
  )
}
